import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate, useLocation } from "react-router-dom";
import { TabsDataLoggedMenu } from "../../../core/models/loggedMenu/loggedMenu.model";
import { useTranslation } from "react-i18next";
import { useState, useMemo, useEffect, useContext } from "react";
import theme from "../../../muiTheme";
import { removeLocalstorageBillsFilters } from "../../../utils/components/bills/bills.util";
import { removeLocalstorageSupplyFilters } from "../../../utils/components/supplies/supplies.util";
import { getUserDataFromLocalStorage } from "../../../core/services/localStorage/localStorage.service";
import TotalEnergiesContext from "../../../core/store/context/TotalEnergiesContext";

interface LoggedMenuProps {
  isDesktopViewport: boolean;
  handleClose: () => void;
}

const LoggedMenu = ({ isDesktopViewport, handleClose }: LoggedMenuProps) => {
  const navigate = useNavigate();
  const { setUserData, isAgent } = useContext(TotalEnergiesContext);
  const location = useLocation();
  const { t } = useTranslation();
  const [tab, setTab] = useState<string | boolean>("home");

  const tabsDataLoggedMenu: TabsDataLoggedMenu[] = useMemo(
    () => [
      ...(!isAgent
        ? [
            {
              id: "home",
              value: "home",
              label: "Inicio",
              href: process.env.REACT_APP_HOME!,
            },
            {
              id: "supplies",
              value: "supplies",
              label: "Suministros",
              href: process.env.REACT_APP_SUPPLIES!,
            },
            {
              id: "bills",
              value: "bills",
              label: "Facturas",
              href: process.env.REACT_APP_BILLS!,
            },
          ]
        : []),
      {
        id: "consumption",
        value: "consumption",
        label: "Consumos",
        href: process.env.REACT_APP_CONSUMPTION!,
      },
      {
        id: "management",
        value: "management",
        label: "Gestiones",
        href: process.env.REACT_APP_MANAGEMENT!,
      } /* 
      {
        id: "services",
        value: "services",
        label: "Servicios",
        href: process.env.REACT_APP_SERVICES!,
      }, */,
    ],
    [isAgent]
  );

  useEffect(() => {
    const tab = tabsDataLoggedMenu.find(({ href }) =>
      location.pathname.includes(href)
    );

    if (tab && !location.search) {
      setTab(tab.value);
      sessionStorage.removeItem(
        process.env.REACT_APP_SESSIONSTORAGE_SUPPLY_SELECTED!
      );
      sessionStorage.removeItem(
        process.env.REACT_APP_SESSIONSTORAGE_BILL_SELECTED!
      );
      return;
    }

    setTab(false);
  }, [location, tabsDataLoggedMenu]);

  const handleTabClickChange = (tabValue: string) => {
    const selectedTab = tabsDataLoggedMenu.find(
      ({ value }) => value === tabValue
    );

    if (selectedTab) {
      navigate(selectedTab.href);
      // setUserData(getUserDataFromLocalStorage());
      setTab(tabValue);
      handleClose();
    }

    //Remove filters
    removeLocalstorageBillsFilters();
    removeLocalstorageSupplyFilters();
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        TabIndicatorProps={{
          style: { backgroundColor: theme.palette.primary.main },
        }}
        value={tab}
        onChange={(event, newValue) => handleTabClickChange(newValue)}
        component={"ul"}
        orientation={isDesktopViewport ? "horizontal" : "vertical"}
        sx={{
          ".MuiTabs-indicator": {
            left: 0,
          },
        }}
      >
        {tabsDataLoggedMenu.map(({ id, label, value }) => (
          <Tab
            key={id}
            component="a"
            onClick={() => value === tab && handleTabClickChange(value)}
            label={t(`Header.Nav.${label}`)}
            value={value}
            sx={{
              fontFamily: "Nunito-Semibold",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: "700",
              color: theme.palette.grey[700],
              "&.Mui-selected": {
                color: theme.palette.primary.main,
              },
              "&:hover": {
                color: theme.palette.primary.main,
              },
            }}
            color="#405258"
            disableRipple
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default LoggedMenu;
